export type BreakpointKeys = keyof typeof breakpoints

export const breakpoints = {
  small: 360,
  mediumSmall: 414,
  medium: 744,
  large: 1024,
  xLarge: 1440,
}
